<template>
  <div
      :class="classes + ' ' + disabled ? 'disabled' : ''"
      class="select-search"
  >
    <model-select
        :options="options"
        v-model="state.item"
        :placeholder="placeholder"
        id="icon"
        :is-disabled="disabled"
    />
  </div>
</template>

<script>
import { reactive, watch } from "@vue/composition-api";
import { ModelSelect } from "vue-search-select";

export default {
  name: "SelectSearch",
  props: {
    classes: String,
    options: Array,
    onOptionSelected: Function,
    selectedOption: Object,
    placeholder: {
      type: String,
      default: "Select",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const state = reactive({
      item: props.selectedOption || {},
    });

    watch(
        () => state.item,
        (item) => {
          props.onOptionSelected(item);
        }
    );

    return {
      state,
    };
  },
  components: {
    ModelSelect,
  },
};
</script>
<style lang="scss">
.select-search {
  .text {
    font-size: 16px;
    line-height: 19px;
  }
  display: flex;
  .disabled {
    // input {
    background: #eee;
    // }
  }
  .ui.fluid.dropdown > .dropdown.icon {
    height: 44px;
  }

  .ui.fluid.dropdown {
    display: flex;
    align-items: center;
  }

  .ui {
    margin-bottom: 30px;
    height: 50px;
    display: flex;
    align-items: center;
    input.search {
      top: -10%;
    }
  }

  #icon,
  .dropdown {
    top: 10%;
    display: flex;
    align-items: center;
  }
}
.form__flex__item {
  .dropdown {
    border: none !important;
  }

  .select-search.disabled {
    background: #ebf0f4;
    .text.default {
      color: black !important;
    }
  }

  .search.selection.dropdown {
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    cursor: pointer;

    input {
      cursor: pointer !important;
    }
  }
}
</style>
